/* eslint-disable */
import Navbar from 'modules/common/components/navbar';
import { useState, useCallback } from 'react';
import { useDropzone } from 'react-dropzone';
import { create } from 'ipfs-http-client';
import toast, { Toaster } from 'react-hot-toast';
import { useFormik } from 'formik';
import * as yup from 'yup';
import { ENVIRONMENT } from 'configs';
// import DialogBox from 'modules/common/components/dialog-box';
import TextField from 'modules/common/components/text-field';
import { useDispatch, useSelector } from 'react-redux';
import { addAdminsSlice } from './slice';
import { addAdminLoader, addAdminSuccess } from './selectors';

let client;

window.Buffer = window.Buffer || require('buffer').Buffer;

const auth = `Basic ${Buffer.from(
  `${ENVIRONMENT.PROJECT_ID}:${ENVIRONMENT.PROJECT_SECRET}`
).toString('base64')}`;

try {
  client = create({
    url: 'https://ipfs.infura.io:5001/api/v0',
    headers: {
      authorization: auth,
    },
  });
} catch (error) {
  client = undefined;
  console.error('IPFS error ', error);
}

const schema = yup.object().shape({
  name: yup.string().required('Name is required'),
  wallet: yup.string().required('Wallet address is required').max(42),
  email: yup.string().email().required('Email is required'),
});

const AddAdmin = () => {
  const dispatch = useDispatch();

  const loading = useSelector(addAdminLoader);
  // const loading = false;
  const success = useSelector(addAdminSuccess);
  // const success = false;

  const [nftFile, setNftFile] = useState();

  const onDrop = useCallback(async (acceptedFiles) => {
    const added = await client?.add({ content: acceptedFiles[0] });
    setNftFile(added?.path);
  }, []);

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    accept: 'image/*',
    onDrop,
  });

  const handleSubmit = async (values, resetForm) => {
    const data = Object.assign(values, { image: nftFile });
    await Promise.resolve(dispatch(addAdminsSlice.actions.addAdmin(data)));
    resetForm();
  };

  const formik = useFormik({
    initialValues: {
      name: '',
      wallet: '',
      email: '',
    },
    validationSchema: schema,
    onSubmit: (val, { resetForm }) => handleSubmit(val, resetForm),
  });
  return (
    <div className="bg-[url('/src/modules/common/assests/images/home-background.png')] bg-no-repeat bg-cover h-screen">
      <Navbar />
      <div className='xl:mt-20 2xl:mt-28 w-full'>
        <div className='container mx-8 lg:mx-auto px-16 py-16 bg-black w-fit lg:w-[1200px] rounded-2xl my-4'>
          <div className='w-full'>
            <div className='flex items-center flex-col lg:flex-row pt-4 lg:pt-0'>
              <div className='lg:basis-2/5 lg:px-8'>
                <h1 className='text-4xl font-semibold text-[#40A838]'>
                  Add New Owner
                </h1>
                <div>
                  <h1 className='font-medium text-white'>
                    Image, Video, Audio, or 3D Model
                  </h1>
                  <p className='text-xs font-medium text-gray-500'>
                    File types supported: JPG, PNG, GIF, SVG. Max size: 05 MB
                  </p>
                </div>
                <div className='mt-8'>
                  <div
                    {...getRootProps()}
                    className='lg:w-96 h-64 border-2 border-dashed rounded-xl border-[#40A838] mt-4 flex justify-center items-center cursor-pointer'
                  >
                    <input {...getInputProps()} />

                    <div className='mx-4'>
                      {isDragActive ? (
                        <img
                          src='https://img.icons8.com/sf-black-filled/128/CCCCCC/image.png'
                          alt='dropbox-icon'
                        />
                      ) : nftFile ? (
                        <div>
                          <img
                            src={`https://ipfs.io/ipfs/${nftFile}`}
                            alt='dropbox-icon'
                            className='w-56'
                          />
                        </div>
                      ) : (
                        <img
                          src='https://img.icons8.com/sf-black-filled/128/CCCCCC/image.png'
                          alt='dropbox-icon'
                        />
                      )}
                    </div>
                  </div>
                </div>
              </div>
              <form
                className='lg:basis-3/5 lg:px-8 lg:py-4 w-full'
                onSubmit={formik.handleSubmit}
                method='POST'
              >
                <div className='my-4'>
                  <TextField
                    lable="Owner's Name"
                    placeholder='John Doe'
                    name='name'
                    value={formik.values.name}
                    onChange={formik.handleChange}
                    error={formik.errors.name && formik.touched.description}
                  />
                  {formik.touched.name && formik.errors.name ? (
                    <span className='text-white'>{formik.errors.name}</span>
                  ) : (
                    ''
                  )}
                </div>
                <div className='my-4'>
                  <TextField
                    lable='Wallet Address'
                    name='wallet'
                    value={formik.values.wallet}
                    onChange={formik.handleChange}
                    placeholder='0x0000000000000000000000000000000000000000'
                    maxLength={42}
                    error={
                      (formik.touched.description && formik.errors.wallet) ||
                      formik.values.wallet.length > 42
                    }
                  />
                  {formik.touched.wallet && formik.errors.wallet ? (
                    <span className='text-white'>{formik.errors.wallet}</span>
                  ) : formik.values.wallet.length >= 42 ? (
                    <span className='text-white'>
                      Wallet address should be less than or equal to 42
                      characters.
                    </span>
                  ) : (
                    ''
                  )}
                </div>
                <div className='my-4'>
                  <TextField
                    lable='Email'
                    placeholder='johndoe@greenartcoin.eu'
                    name='email'
                    type='email'
                    value={formik.values.email}
                    onChange={formik.handleChange}
                    error={formik.touched.description && formik.errors.email}
                  />
                  {formik.touched.email && formik.errors.email ? (
                    <span className='text-white'>{formik.errors.email}</span>
                  ) : (
                    ''
                  )}
                </div>
                <div className='my-6 flex justify-end'>
                  {loading ? (
                    <button
                      // onClick={handleSubmit}
                      // type="submit"
                      disabled
                      className='bg-gradient-to-b from-[#274728] to-[#40A838] px-6 py-3 text-white rounded-lg font-medium flex cursor-wait'
                    >
                      <svg
                        className='mr-3 h-5 w-5 animate-spin text-white'
                        xmlns='http://www.w3.org/2000/svg'
                        fill='none'
                        viewBox='0 0 24 24'
                      >
                        <circle
                          className='opacity-25'
                          cx='12'
                          cy='12'
                          r='10'
                          stroke='currentColor'
                          strokeWidth='4'
                        />
                        <path
                          className='opacity-75'
                          fill='currentColor'
                          d='M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z'
                        />
                      </svg>
                      Loading...
                    </button>
                  ) : (
                    // : success ? (
                    //   toast.success('Artwork added successfully.', {
                    //     position: 'bottom-center',
                    //   })

                    // )
                    <button
                      // onClick={handleSubmit}
                      type='submit'
                      className='bg-gradient-to-b from-[#274728] to-[#40A838] p-1 shadow-lg shadow-green-500/50 hover:shadow-green-500/75 text-white font-medium hover:text-white px-6 py-3 rounded-lg ease-in duration-300'
                    >
                      Add owners
                    </button>
                  )}
                </div>
              </form>
            </div>
          </div>
        </div>
        {/* <DialogBox
          open={isOpen}
          closeModal={closeModal}
          setProperty={(property) => {
            setProperties(property);
          }}
        /> */}
      </div>
      <Toaster />
    </div>
  );
};

export default AddAdmin;
